import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addedFemaleBeneficiary:
      '{name} has been added to the list of beneficial owners.',
    addedMaleBeneficiary:
      '{name} has been added to the list of beneficial owners.',
    cancel: 'Cancel',
    cta: 'Add',
    title: 'Add a beneficial owner',
  },
  fr: {
    addedFemaleBeneficiary: `{name} a été ajoutée à la liste des bénéficiaires effectifs`,
    addedMaleBeneficiary: `{name} a été ajouté à la liste des bénéficiaires effectifs`,
    cancel: 'Annuler',
    cta: 'Ajouter',
    title: 'Ajoutez un bénéficiaire effectif',
  },
} as const);
